var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 60,
    viewBox: "0 0 20 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 42.2071C9.68341 42.5976 10.3166 42.5976 10.7071 42.2071L17.0711 35.8431C17.4616 35.4526 17.4616 34.8195 17.0711 34.4289C16.6805 34.0384 16.0474 34.0384 15.6569 34.4289L10 40.0858L4.34314 34.4289C3.95262 34.0384 3.31945 34.0384 2.92893 34.4289C2.53841 34.8195 2.53841 35.4526 2.92893 35.8431L9.29289 42.2071ZM10 9.5L9 9.5L9 41.5L10 41.5L11 41.5L11 9.5L10 9.5Z",
    fill: "#4A5D68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.39ce6d0c0b3a0907f9aace4af492dbcd.svg";
export { ForwardRef as ReactComponent };